import { Injectable } from "@angular/core";
import { Course, CoursePage, PostResponse, ProductVersionJaiceDetails } from "@data/course";
import { ServiceResponse } from "@data/response";
import { API } from "@service/system/api.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class CourseDetailsService {
	private _coursesURL = `${API_URL}/course`;

	constructor(private responseHandler: ResponseHandler) {}

	getCourses(): Observable<ServiceResponse<Course[]>> {
		return this.responseHandler.httpGet<Course[]>(this._coursesURL);
	}

	getCourseByTitle(searchText: string | string[]): Observable<ServiceResponse<Course[]>> {
		if (searchText == null) {
			return this.responseHandler.httpGet<Course[]>(this._coursesURL);
		}
		return this.responseHandler.httpGet<Course[]>(`${this._coursesURL}/find`, { title: searchText });
	}

	getCourseByGUID(cvItemID: string): Observable<ServiceResponse<Course[]>> {
		if (cvItemID.length < 1) {
			return this.responseHandler.httpGet<Course[]>(this._coursesURL);
		}
		return this.responseHandler.httpGet<Course[]>(`${this._coursesURL}/${cvItemID}/find`);
	}

	getCoursePagesByGUID(guid: string): Observable<ServiceResponse<CoursePage[]>> {
		return this.responseHandler.httpGet<CoursePage[]>(`${this._coursesURL}/${guid}/pages`);
	}

	updateCourseVersion(cvItemID: string, body: string): Observable<ServiceResponse<string>> {
		return this.responseHandler.httpPost<string>(`${this._coursesURL}/${cvItemID}/set`, body);
	}

	setCourseVersionStatus(cvItemID: string, body: any): Observable<ServiceResponse<PostResponse>> {
		return this.responseHandler.httpPost<PostResponse>(`${this._coursesURL}/${cvItemID}/status/set`, body);
	}
}
